import { useParams, useNavigate } from "react-router-dom";

export const useTrainingRoute = () => {
  const { trainingId, topicId, topicPartId } = useParams();
  const navigate = useNavigate();

  // Fonction pour générer les chemins
  const trainingPath = (id?: string | number | null) =>
    id || trainingId ? `/topic/${id ?? trainingId}` : "/topic";

  const topicPath = (id?: string | number | null) =>
    id || topicId
      ? `/topic/${trainingId}/${id ?? topicId}`
      : `/topic/${trainingId}`;

  const topicPartPath = (id: string | number) =>
    `/topic/${trainingId}/${topicId}/${id}`;

  const categoryPath = (id?: string | number | null) =>
    id || trainingId ? `/category/${id ?? trainingId}` : "/category";

  const testimonyPath = (id?: string | number | null) =>
    id || trainingId ? `/testimony/${id ?? trainingId}` : "/testimony";

  const trainingVersionsPath = (id?: string | number | null) =>
    id || trainingId
      ? `/training-versions/${id ?? trainingId}`
      : "/training-versions";

  // Fonction pour naviguer vers une route donnée
  const navigateTo = (path: string) => {
    navigate(path);
  };

  const pathname = location.pathname;
  const isTopicRoute =
    pathname === "/topic" || pathname.startsWith("/topic/");
  const isCategoryRoute = location.pathname.includes("/category");
  const isTestimonyRoute = location.pathname.includes("/testimony");
  const isTrainingVersionsRoute =
    location.pathname.includes("/training-versions");
  return {
    trainingId: trainingId,
    topicId: topicId,
    topicPartId: topicPartId,
    isNew: topicId === "new" || topicPartId === "new",
    isTopicRoute,
    isTestimonyRoute,
    isTrainingVersionsRoute,
    isCategoryRoute,
    trainingPath,
    topicPath,
    topicPartPath,
    categoryPath,
    testimonyPath,
    trainingVersionsPath,
    navigateTo,
  };
};
